import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class EntityFormRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig === curr.routeConfig && !this.hasSameParams(future.params, curr.params)) {
      return false;
    }

    return super.shouldReuseRoute(future, curr);
  }

  private hasSameParams(
    futureParams: ActivatedRouteSnapshot['params'],
    currentParams: ActivatedRouteSnapshot['params']
  ): boolean {
    const futureKeys = Object.keys(futureParams);
    const currentKeys = Object.keys(currentParams);

    if (futureKeys.length !== currentKeys.length) {
      return false;
    }

    return futureKeys.every((key) => futureParams[key] === currentParams[key]);
  }
}
